// Self-host Monaco (spec §6.2, §11 strict CSP).
//
// @monaco-editor/react loads the editor from a jsdelivr CDN by default. The app's
// production CSP (`script-src 'self'`) blocks that, so the editor would hang on
// "Loading…". Bundling Monaco and pointing the loader at it keeps the editor
// self-contained and CDN-free — everything is served same-origin.
//
// Slim import: just the editor API + the Python language grammar (no JSON/TS/CSS
// language services), so the bundle stays small. Python highlighting is a
// synchronous Monarch grammar, so only the base editor worker is needed.
import * as monaco from "monaco-editor/esm/vs/editor/editor.api";
import "monaco-editor/esm/vs/basic-languages/python/python.contribution";
import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
import { loader } from "@monaco-editor/react";

self.MonacoEnvironment = {
  getWorker: () => new editorWorker(),
};

loader.config({ monaco });
